import axios, { AxiosError } from "axios";
import { useMutation, UseMutationOptions } from "react-query";

import { getAppConfigSetting } from "../utils/getAppConfigSetting";
import { CLOSE_CALL_API } from "./constants";

export interface CloseMarginCallResponse {}

export function useCloseMarginCall(
  entityId: string,
  account: string,
  options: UseMutationOptions<
    CloseMarginCallResponse,
    AxiosError<{ errorDescription: string }>,
    {}
  >
) {
  const closeMarginCallEndpoint = `${getAppConfigSetting(
    "apiUrl"
  )}${CLOSE_CALL_API(entityId)}`;

  const closeMarginCall = async (note: string) => {
    const { data } = await axios.post(
      closeMarginCallEndpoint,
      { note },
      {
        withCredentials: true,
      }
    );
    return data as CloseMarginCallResponse;
  };
  return useMutation(closeMarginCall, {
    retry: false,
    ...options,
  });
}
